'use strict';
const angular = require('angular');
const {noop} = angular;

module.exports = [
  '$window',
  KeyboardAdjustmentDirective];

// Apply a spacer to manually shrink the view height by the height of the keyboard in iOS
function KeyboardAdjustmentDirective($window) {

  function link(scope, element, attrs) {

    if (ionic.Platform.isAndroid()) {
      // Android shrinks the actual view by the height of the keyboard so we do not need this spacer
      $window.requestAnimationFrame(function () {
        element.css('display', 'none');
      })

    } else {
      $window.addEventListener('native.keyboardshow', keyboardShowHandler);
      $window.addEventListener('native.keyboardhide', keyboardHideHandler);

      scope.$on('$destroy', function () {
        $window.removeEventListener('native.keyboardshow', keyboardShowHandler);
        $window.removeEventListener('native.keyboardhide', keyboardHideHandler);
      })
    }

    function keyboardShowHandler(e) {
      element.css('flex', '0 0 ' + e.keyboardHeight + 'px');
    }

    function keyboardHideHandler(e) {
      element.css('flex', '0 0 0');
    }
  }

  return {
    restrict: 'A',
    link: ionic.Platform.isWebView() ? link : noop
  };
}



// WEBPACK FOOTER //
// ./src/js/core-utilities-implementation/ionic-keyboard/KeyboardAdjustmentDirective.js